import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  UiMoleculeDialogExportColumnsComponent,
  ExportColumnsDialogData,
} from '../components/molecules/ui-molecule-dialog-export-columns/ui-molecule-dialog-export-columns.component';
import { TableColumn } from '../components/molecules/ui-molecule-mat-table/interfaces/table-column';

@Injectable({
  providedIn: 'root',
})
export class DialogExportColumnsService {
  constructor(private dialog: MatDialog) {}

  open(
    columns: TableColumn[],
    options?: Omit<ExportColumnsDialogData, 'columns'>,
  ): Observable<string[] | null> {
    const data: ExportColumnsDialogData = { columns, ...options };
    const ref = this.dialog.open(UiMoleculeDialogExportColumnsComponent, {
      panelClass: ['dialog-sm', 'dialog-safe-area', 'dialog-flex'],
      disableClose: false,
      autoFocus: false,
      data,
    });
    return ref.afterClosed();
  }
}
